import { Popover } from 'antd';
import { ShortcutKey } from 'components/common/ShortcutHint/ShortcutHint';
import {
  ROTATION_HELP_FOOTNOTE,
  ROTATION_HELP_ITEMS,
} from 'constants/messageConstants';
import { ROTATION_HELP_LABEL } from 'constants/uiConstants';
import React from 'react';
import { LuHelpCircle } from 'react-icons/lu';
import { PILL_BUTTON_CLASS } from './RotationViewOptions';

/**
 * "How to use" for the Rotation planner (OP-2501): the grid's mouse and
 * keyboard actions, on demand. It replaces instruction text around the
 * controls, so it's there for a first-time user without nagging anyone
 * who already knows.
 */
const RotationHelp: React.FC = () => {
  const content = (
    <div className="flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2 p-1">
      <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-2 text-sm">
        {ROTATION_HELP_ITEMS.map((item) => (
          <React.Fragment key={item.text}>
            <dt className="flex flex-col items-start gap-1">
              {item.keys.map((key) => (
                <ShortcutKey key={key} variant="subtle">
                  {key}
                </ShortcutKey>
              ))}
            </dt>
            <dd className="text-charcoal">{item.text}</dd>
          </React.Fragment>
        ))}
      </dl>
      <p className="border-t border-gray-bright pt-2 text-sm text-gray-dark">
        {ROTATION_HELP_FOOTNOTE}
      </p>
    </div>
  );

  return (
    <Popover trigger="click" placement="bottomRight" content={content}>
      <button type="button" className={PILL_BUTTON_CLASS}>
        <LuHelpCircle size={14} aria-hidden />
        {ROTATION_HELP_LABEL}
      </button>
    </Popover>
  );
};

export default RotationHelp;
